<div class="wrapper">
    <!-- start .row -->
    <div class="row">
        <div class="col-sm-12 wtw-hero-image">
            <img id="BGprincipal" class="img-responsive" src="./assets/global/images/cabeceras/bg_admin_auditoria.jpg">
            <h1 class="wtw-bg-black col-lg-5" style="margin-left: 15px">Administración</h1>
        </div>
    </div>
    <!-- end .row -->

    <div class="container-fluid">

        <!-- Page-Title -->
        <div class="row">
            <div class="col-sm-12">
                <div class="page-title-box">
                    <div class="btn-group pull-right">
                        <ol class="breadcrumb hide-phone p-0 m-0">
                            <li class="breadcrumb-item"><a href="#">Inicio</a></li>
                            <li class="breadcrumb-item"><a href="#">Administración</a></li>
                            <li class="breadcrumb-item"><a href="#">Paramétricas</a></li>
                            <li class="breadcrumb-item"><a href="#">Amparos</a></li>
                        </ol>
                    </div>
                    <h4 class="page-title">Administración Paramétricas</h4>
                </div>
            </div>
        </div>
        <!-- end page title end breadcrumb -->
        <div class="row">
            <div class="col-md-12">
                <div class="card-box">
                    <h4 class="m-t-0 header-title">Información Amparos</h4>

                    <form [formGroup]="formAmparo">
                        <div class="form-row ">
                            <div class="form-group col-md-6">
                                <label for="userName">Ramo<span class="text-danger">*</span></label>
                                <ng-select2 formControlName="ramo" id="select-ramo"
                                    (valueChanged)="refreshListByramo($event)" [data]="ListRamos"
                                    class="form-control">
                                </ng-select2>
                            </div>
                            <div class="form-group col-md-6">
                                <label for="userName">Nombre Amparo<span class="text-danger">*</span></label>
                                <input type="text" name="nick" parsley-trigger="change" required
                                    placeholder="Escriba el nombre del Amparo" class="form-control"
                                    formControlName="nombre" id="nameamparo">
                            </div>

                            <div class="actions clearfix">
                                <button *ngIf="!edit" (click)="onSubmit()" type="button"
                                    class="btn btn-custom waves-effect waves-light">
                                    <i class="fi-plus"></i>Agregar
                                </button>
                                <button *ngIf="edit" (click)="updateAmparo()" type="button"
                                    class="btn btn-custom waves-effect waves-light">
                                    <i class="fi-plus"></i>Agregar Cambio
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="card-box table-responsive">
                    <div id="key-table_wrapper" class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer">
                        <div class="row">
                            <div class="col-sm-12">
                                <div style="position: absolute; height: 1px; width: 0px; overflow: hidden;"><input
                                        type="text" tabindex="0"></div>
                                <table class="table table-hover m-0 tickets-list table-actions-bar dt-responsive nowrap"
                                    cellspacing="0" width="100%" id="datatable">
                                    <thead>
                                        <tr>
                                            <th>Nombre Amparo</th>
                                            <th>Modificar</th>
                                            <th>Eliminar</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let item of ListAmparos">
                                            <td>{{item.nombre}}</td>
                                            <td><a (click)="editAmparo(item.nombre,item.idAdmAmparo)"
                                                    class="btn btn-sm btn-purple"><i class="mdi mdi-pencil"></i></a>

                                            <td><a (click)="deleteAmparo(item.idAdmAmparo)"
                                                    class="btn btn-sm btn-danger"><i class="mdi mdi-delete"></i></a>
                                            </td>


                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- <div class="row">
            <div class="col-12">
                <div class="card-box table-responsive">
                    <div id="key-table_wrapper" class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer">
                        <div class="row">
                            <div class="col-sm-12">
                                <div style="position: absolute; height: 1px; width: 0px; overflow: hidden;"><input
                                        type="text" tabindex="0"></div>
                                <table class="table table-hover m-0 tickets-list table-actions-bar dt-responsive nowrap"
                                    cellspacing="0" width="100%" id="datatable"
                                    *ngIf="amparosService.listAmparos && amparosService.listAmparos.length">
                                    <thead>
                                        <tr role="row">
                                            <th class="sorting_asc" tabindex="0" aria-controls="key-table" rowspan="1"
                                                colspan="1" aria-sort="ascending"
                                                aria-label="Name: activate to sort column descending"
                                                style="width: 500px;;">Nombre Amparo</th>
                                            <th class="sorting" tabindex="0" aria-controls="key-table" rowspan="1"
                                                colspan="1" aria-label="Position: activate to sort column ascending"
                                                style="width: 30%;">Modificar</th>
                                            <th class="sorting" tabindex="0" aria-controls="key-table" rowspan="1"
                                                colspan="1" aria-label="Position: activate to sort column ascending"
                                                style="width: 30%;">Eliminar</th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        <tr role="row" class="odd" *ngFor="let item of amparosService.listAmparos">
                                            <td class="sorting_1">{{item.nombre}}</td>
                                            <td>
                                                <div class="btn-group dropdown">
                                                    <a href="javascript: void(0);"
                                                        class="table-action-btn dropdown-toggle arrow-none btn btn-sm btn btn-icon waves-effect waves-light btn-purple"
                                                        data-toggle="dropdown" aria-expanded="false"><i
                                                            class="mdi mdi-border-color"></i></a>
                                                    <div class="dropdown-menu dropdown-menu-right">
                                                        <a class="dropdown-item"
                                                            (click)="editAmparo(item.nombre,item.idAdmAmparo)"><i
                                                                class="mdi mdi-table-edit mr-2 text-muted font-18 vertical-middle"></i>Editar</a>
                                                        <a class="dropdown-item"
                                                            (click)="editAmparo(item.nombre,item.idAdmAmparo)"><i
                                                                class="mdi mdi-lead-pencil mr-2 text-muted font-18 vertical-middle"></i>Editar
                                                            Amparo</a>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="btn-group dropdown">
                                                    <a href="javascript: void(0);"
                                                        class="table-action-btn dropdown-toggle arrow-none btn btn-sm btn-danger"
                                                        data-toggle="dropdown" aria-expanded="false"><i
                                                            class="mdi mdi-delete"></i></a>
                                                    <div class="dropdown-menu dropdown-menu-right">
                                                        <a class="dropdown-item"
                                                            (click)="deleteAmparo(item.idAdmAmparo)"><i
                                                                class="mdi mdi-delete-forever mr-2 text-muted font-18 vertical-middle"></i>Eliminar</a>
                                                        <a class="dropdown-item"
                                                            (click)="deleteAmparo(item.idAdmAmparo)"><i
                                                                class="mdi mdi-delete mr-2 text-muted font-18 vertical-middle"></i>Eliminar
                                                            Amparo</a>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
    </div> <!-- end container -->
</div>
<!-- end wrapper -->
<div class="blanco"></div>